import React, { Component } from "react";
import { connect } from "react-redux";

import { enTokenCMD } from "../lib/classTalk/CodeEnum";
import { ctActionType } from "../lib/ConstCommand";

import {
    whisperPopupInitialize,
    appendSendMessage,
    appendSendAudioMemo,
    appendSendFileShare,
    emoticonSelectedToggle,
    selectEmoticonSeq,
    emoticonSelectedCancel,
    addFunctionOpenedToggle,
    selectFunctionSeq,
    inkMemoOpenedToggle,
    voiceMemoClosedToggle,
    fileShareToggle,
    fileOpenToggle,
    imgThumbnailClick
} from "../modules/whisper";
import { openContentSendPanel } from "../modules/classTalk";

import WhisperChattingInfo from "../components/pblWhisper/WhisperChattingInfo";
import ClassTalk from "../components/pblWhisper/ClassTalk";

class PBLWhisperPopupContainer extends Component {

    componentDidMount() {
        console.log("PBLWhisperPopupContainer componentDidMount");

        const { routeProps } = this.props;
        if (routeProps.match && routeProps.match.params) {
            const stdSeq = routeProps.match.params.stdSeq;
            console.log("PBLWhisperPopupContainer - have to stdSeq : ", stdSeq);

            if (Number(stdSeq) > 0) {
                this.props.whisperPopupInitialize({ stdSeq });
            }
        }
    }

    handleSelectedClassTalkFunc = ({ selectedFunc, emoticonSeq, func, msgText, data, filename, fileURL, idx, fileType, source, mode, memberSeq }) => {
        const { userSeq, userNickname } = this.props;

        console.log(`selectedFunc[${selectedFunc}], msgText[`, msgText, `], data[`, data, `]`);
        switch (selectedFunc) {
            // --------------------------- Emoticon --------------------------- //
            case "EMOTICON_TOGGLE":
                this.props.emoticonSelectedToggle();
                break;

            case "EMOTICON_SELECT":
                this.props.selectEmoticonSeq(emoticonSeq);
                break;

            case "EMOTICON_CANCLE":
                this.props.emoticonSelectedCancel();
                break;

            // --------------------------- Send message --------------------------- //

            case "SEND_MSG":
                console.log('send msg ; ', msgText);
                this.props.appendSendMessage({ msgText, liveSeq: this.props.activeLive.liveSeq, userSeq, userNickname });
                // this.props.appendSendMessage({ msgText, liveSeq: this.props.activeLive.liveSeq, userSeq, userNickname }); 
                break;

            case "SEND_VOICE_MEMO":
                this.props.appendSendAudioMemo({ data, url: fileURL, liveSeq: this.props.activeLive.liveSeq, userSeq, userNickname });
                // this.props.appendSendAudioMemo({ selectedFunc, data, url: fileURL, liveSeq: this.props.activeLive.liveSeq, userSeq, userNickname });
                break;

            // --------------------------- Classtalk func --------------------------- //

            case "FUNC_TOGGLE":
                this.props.addFunctionOpenedToggle();
                break;

            case "FUNC_SELECT":
                this.props.selectFunctionSeq({ func, mode: "hiclass", liveSeq: this.props.activeLive.liveSeq, userSeq, userNickname, memberSeqList: [this.props.stdInfo.stdSeq] });

                switch (func) {
                    case ctActionType.InkMemo:
                        // this.props.inkMemoOpenedToggle({ performChatRoomSeq: performChatRoomInfo.chatRoomSeq, liveSeq: this.props.activeLive.liveSeq, userSeq, userNickname });
                        break;

                    // 여기 이제 안불려야 함.........
                    case ctActionType.FileShare:
                        let chatRoomSeq = 0;
                        // if (performChatRoomInfo.chatRoomSeq !== -1) chatRoomSeq = performChatRoomInfo.chatRoomSeq;

                        this.props.appendSendFileShare({
                            mode: "new-hiclass",
                            chatRoomSeq,
                            data,
                            teacherSeq: userSeq,
                            filename,
                            liveSeq: this.props.activeLive.liveSeq,
                            userSeq,
                            userNickname,
                            command: enTokenCMD.ct_UploadAndShareFiles,
                            memberSeqList: [{ userSeq: this.props.stdInfo.stdSeq }],
                            mixedClassStatus: this.props.mixedClassStatus
                        });
                        break;

                    default:
                        break;
                }
                break;

            case "CLOSE_VOICE_MEMO":
                this.props.voiceMemoClosedToggle();
                break;

            case "INK_MEMO":
                this.props.inkMemoOpenedToggle({ selectedFunc, imgUrl: fileURL, liveSeq: this.props.activeLive.liveSeq, userSeq, userNickname /**, performChatRoomSeq: performChatRoomInfo.chatRoomSeq */ });
                break;

            case "PAGE_JPEG":
                this.props.imgThumbnailClick({ imgDataUrl: fileURL, idx });
                break;

            case "FILE_DOWNLOAD":
                this.props.fileShareToggle({ fileURL, originalFileName: filename, idx });
                break;

            case "FILE_OPEN":
                // console.log(`handleSelectedClassTalkFunc - fileType[${fileType}]`);
                this.props.fileOpenToggle({ fileURL, originalFileName: filename, fileType });
                break;

            case "CALL_EO_FOR_FILE_SHARE":
                let chatRoomSeq = 0;
                // if (performChatRoomInfo.chatRoomSeq !== -1) chatRoomSeq = performChatRoomInfo.chatRoomSeq;

                this.props.appendSendFileShare({
                    mode: "hiclass",
                    chatRoomSeq,
                    teacherSeq: userSeq,
                    liveSeq: this.props.activeLive.liveSeq,
                    userSeq,
                    userNickname,
                    command: enTokenCMD.ct_UploadAndShareFiles,
                    memberSeqList: [{ userSeq: this.props.stdInfo.stdSeq }],
                    mixedClassStatus: this.props.mixedClassStatus
                });
                break;

            case "OPEN_CONTENT_SEND_PANEL":
                this.props.openContentSendPanel({
                    msgInfo: data,
                    idx,
                    source: source ? source : "whisper",
                    mode: mode ? mode : "content",
                    memberSeq: memberSeq ? memberSeq : this.props.stdInfo.stdSeq
                });
                break;

            default:
                break;
        }
    }

    render() {
        return (
            <>
                <WhisperChattingInfo
                    stdInfo={this.props.stdInfo}
                />
                <ClassTalk
                    openInfo={this.props.openInfo}
                    classTalkMsg={this.props.whisperMsg}
                    progressCount={this.props.progressCount}
                    isProgressBarShow={this.props.isProgressBarShow}
                    whisperMemberSeq={this.props.stdInfo.stdSeq}
                    handleSelectedClassTalkFunc={this.handleSelectedClassTalkFunc}
                /> 
            </>
        );
    }
}

export default connect(
    ({ live, whisper }) => ({
        userSeq                     : whisper.userInfo.userSeq,
        userNickname                : whisper.userInfo.userNickname,

        stdInfo                     : whisper.stdInfo,

        whisperMsg                  : whisper.whisperMsg,

        openInfo                    : {
            isEmoticonSelected      : whisper.isEmoticonSelected,
            selectedEmoticonSeq     : whisper.selectedEmoticonSeq,
            isAddFunctionOpened     : whisper.isAddFunctionOpened,
            isAudioOpened           : whisper.isAudioOpened,
            audioStatus             : whisper.audioStatus,
            selectedFunctionSeq     : whisper.selectedFunctionSeq
        },

        isProgressBarShow           : whisper.isProgressBarShow,
        progressCount               : whisper.progressCount,

        activeLive                  : live.list_live.find(info => info.selectStatus === "Y") !== undefined && 
                                      live.list_live.find(info => info.selectStatus === "Y") !== null ?
                                      live.list_live.find(info => info.selectStatus === "Y") :
                                      {
                                          liveSeq: -1,
                                          liveName: "",
                                          list_member: [],
                                          mixedClassStatus: "N"
                                      },

        isMixedClassMember          : live.isMixedClassMember,
        mixedClassStatus            : live.performLiveInfo.mixedClassStatus
    }),
    {
        emoticonSelectedToggle,
        selectEmoticonSeq,
        emoticonSelectedCancel,

        appendSendMessage,
        appendSendAudioMemo,
        appendSendFileShare,

        selectFunctionSeq,
        addFunctionOpenedToggle,
        voiceMemoClosedToggle,
        inkMemoOpenedToggle,
        imgThumbnailClick,
        fileShareToggle,
        fileOpenToggle,

        whisperPopupInitialize,
        openContentSendPanel
    }
)(PBLWhisperPopupContainer);
